import { render } from "./Forms.vue?vue&type=template&id=07824d4d"
import script from "./Forms.vue?vue&type=script&lang=ts"
export * from "./Forms.vue?vue&type=script&lang=ts"
script.render = render

export default script